<template lang="pug">
  include /mixins
  +b.tt-product_in_cart_wrapper(v-if='product.element && product.element.props.product')
    ui-loader(v-if='load || localLoad')
    +b.product_in_cart.relative 
      +b.tt-product_in_cart-labels(
        :class="{'is-active' : true}"
      )
        template(v-if='product.parameters && product.element.props.product.props.brand.props.is_partner')
          +e.label
            +b.label.--static.--variant_1.is_partner
              +e.title.--size_1.P {{ _('Партнер') }}
        template(v-if='product.parameters && product.parameters.is_sale_applied')
          +e.label
            +b.label--static.--variant_1.is_sale
              +e.title.--size_1.P {{ _('Акция') }}
        template(v-if="!isCartModal && product.parameters && product.parameters.quality_type_id")
          +e.label
            +b.label--static.--variant_1.is_discount
              +e.title.--size_1.P {{ _('Уценка') }}
          //- template(v-if="product.parameters && product.parameters.is_new")
          //-   +e.label
          //-     +b.label--static.--variant_1.is_new
          //-       +e.title.--size_1.P {{ _('new') }}
          //- template(v-if="product.parameters && product.parameters.is_hit")
          //-   +e.label
          //-     +b.label--static.--variant_1.is_top
          //-       +e.title.--size_1.P {{ _('ТОП') }}
          //- template(v-if="product.parameters && product.parameters.is_sale")
          //-   +e.label
          //-     +b.label--static.--variant_1.is_sale
          //-       +e.title.--size_1.P {{ _('акция') }}
      slot(name='gift')
        +b.product-gift-info(
          v-if='isSale && product.parameters && product.parameters.select_gift'
          @click.prevent='openGiftVariants'
        )
          +b.product-gift
            +e.icon.icon-gift.SPAN
          +e.title.tt-link--styling_default.P {{ _('Выбрать другой подарок') }}
        +b.product-gift-info(
          v-if='isSale && product.parameters && !product.parameters.select_gift'
        )
          +b.product-gift
            +e.icon.icon-gift.SPAN
      +b.tt-card-product-inner(
        :class=' isSimple ? "tt-card-product-inner--space_none tt-card-product-inner--simple" : isGiftSelect ? "tt-card-product-inner--offset_none tt-card-product-inner--flex-column" : ""'
      )
        +b.g-row--align_center.--justify_center(
          :class='{ "flex_1": isGiftSelect }'
        )
          +b.g-cell.g-cols.relative(
            :class="isGiftSelect ? 'g-cols--narrow' : 'g-cols--3 g-cols--3 g-cols--2-xl'"
          )
            +b.tt-picture--size_contain.tt-cart-product-img.PICTURE.relative.tt-space_mr--2(
              :class='{ "tt-cart-product-img--mini": !isGiftSelect }'
            )
              source(
                type="image/webp"
                v-if='!product.element.props.weight.props.img'
                :srcset="product.element.props.img && product.element.props.img.catalog_preview_webp"
              )
              +e.body.IMG(
                v-if='product.element.props.weight.props.img || (product.element.props.img && product.element.props.img.catalog_preview)'
                :src='product.element.props.weight.props.img || (product.element.props.img && product.element.props.img.catalog_preview)',
                :alt='product.element.props.title',
              )
              +e.body.IMG(
                v-else
                src='https://via.placeholder.com/60x60',
              )
            +b.cart-label-wrap
              //- +b.cart-label--static.is_sale(
              //-   v-if='product.parameters && product.parameters.is_sale_applied'
              //- )
              //-   +e.title.P {{ _('акция') }}
              template(
                v-for='rel in relations'
              )
                //- +b.cart-label--static.is_sale(
                //-   v-if='(rel && rel.parameters && rel.element && rel.element.type !== $options.PROMO_TYPE) || rel && rel.element && rel.element.props && rel.element.props.campaign && rel.element.props.campaign.id'
                //- )
                //-   +e.title.P {{ _('акция') }}
                +b.cart-label--static.is_sale(
                  v-if='(rel && rel.parameters && rel.element && rel.element.type == $options.PROMO_TYPE)'
                )
                  +e.title.P {{ _('промокод') }}
              //- +b.cart-label--static.is-discount(
              //-   v-if='product.parameters && product.parameters.quality_type_id'
              //- )
              //-   +e.title.P {{ _('Уценка') }}
          +b.g-cell.g-cols(
            :class="isGiftSelect ? 'g-cols--auto g-cols--12-xl' : 'g-cols--9 g-cols--10-xl'"
          )
            +b.g-row--appearance_column.--justify_between.full-h
              +b.g-cell.g-cols--12
                +b.g-row.--justify_between.full-h
                  +b.g-cell.g-cols--12
                    +b.g-row.--justify_between
                      +b.g-cell.g-cols
                        +b.ds-caption--size_sm.--medium(
                        ) {{ product.element.props.product.props.brand.props.title }}
                      //- +b.g-cell.g-cols.is-disable-xl
                      //-   +b.ds-caption--size_xs.--appearance_right-md.P {{ product.element.props.vendor_code }}
                      //-   slot(name='mob-vendor')
                    +b.ds-caption--size_2md.--size_sm-3md-xl.--bold.--lh_25.tt-link--variant_start.A(
                      :class='{ "is-disabled": !product.element.props.show_in_catalog }'
                      :href='product.element.props.variant_url'
                    ) {{ product.element.caption }}
                  +b.g-cell.g-cols--12
                    +b.g-row--appearance_nowrap.--align_center.--space_none.tt-space_mt--3
                      +b.g-cell.g-cols.tt-space_mr--2(
                        style='flex-shrink: 0'
                        v-if='product.element.props.weight.props.img || product.element.props.weight.props.color'
                      )
                        +b.product-weight-color-trigger
                          +e.color.IMG(
                            v-if='product.element.props.weight.props.img'
                            :src='product.element.props.weight.props.img'
                          )
                          +e.color(
                            v-else
                            :style='{ "--color": product.element.props.weight.props.color }'
                          )
                      +b.g-cell.g-cols
                        +b.ds-caption--size_2xs.--color-relief.--medium.P(v-if='product.element.props.weight.props.color_number') {{ product.element.props.weight.props.color_number }} ({{ product.element.props.weight.props.name }})
                        +b.ds-caption--size_2xs.--color-relief.--medium.P(v-else) {{ product.element.props.weight.props.name }}
                  +b.g-cell.g-cols--12(:class='{ "is-visible-xl": !isSimple }')
                    +b.g-row.--justify_between
                      +b.g-cell.g-cols.--narrow-sm
                        +b.tt-article(:class='{ "tt-cart-product-article": !isSimple }' v-if='!isGiftSelect')
                          +b.ds-caption--size_xs.SPAN {{ _('Артикул:') }} {{ product.element.props.vendor_code }}
                        +b.tt-space_mb--5(v-else)
                      +b.g-cell.g-cols.--narrow-sm(v-if="!isCartModal && bonus")
                        +b.tt-cart-product-cashback
                          +e.icon.SVG(:title='_("cashback")' xmlns='http://www.w3.org/2000/svg', width='20', height='20', viewBox!='0 0 20 20', fill='none')
                            circle(cx='10' cy='10' r='10' fill='#FF7A00')
                            circle(cx='10' cy='10' r='8.5' fill='#FF7A00' stroke='white')
                            path(d='M10.5398 15C9.74432 15 9.00568 14.8816 8.32386 14.6448C7.65152 14.3989 7.06439 14.0528 6.5625 13.6066C6.07008 13.1603 5.68655 12.6321 5.41193 12.0219C5.13731 11.4117 5 10.7377 5 10C5 9.2623 5.13731 8.58834 5.41193 7.97814C5.68655 7.36794 6.07008 6.83971 6.5625 6.39344C7.06439 5.94718 7.65152 5.60565 8.32386 5.36885C9.00568 5.12295 9.74432 5 10.5398 5C11.5152 5 12.3769 5.16393 13.125 5.4918C13.8826 5.81967 14.5076 6.29326 15 6.91257L12.8835 8.72951C12.59 8.37432 12.2633 8.10109 11.9034 7.90984C11.553 7.70947 11.1553 7.60929 10.7102 7.60929C10.3598 7.60929 10.0426 7.66393 9.75852 7.77322C9.47443 7.88251 9.22822 8.04189 9.01989 8.25137C8.82102 8.46084 8.66477 8.71585 8.55114 9.01639C8.4375 9.30783 8.38068 9.6357 8.38068 10C8.38068 10.3643 8.4375 10.6967 8.55114 10.9973C8.66477 11.2887 8.82102 11.5392 9.01989 11.7486C9.22822 11.9581 9.47443 12.1175 9.75852 12.2268C10.0426 12.3361 10.3598 12.3907 10.7102 12.3907C11.1553 12.3907 11.553 12.2951 11.9034 12.1038C12.2633 11.9035 12.59 11.6257 12.8835 11.2705L15 13.0874C14.5076 13.6976 13.8826 14.1712 13.125 14.5082C12.3769 14.8361 11.5152 15 10.5398 15Z' fill='white')
                          +e.value.ds-caption--size_sm.--semibold(v-html='getSplittedHtml(bonus)')
              +b.g-cell.g-cols--12.--6-xl
                +b.ds-caption--size_2xs.--medium.seller-product-name.tt-space_mb--3.P(
                  v-if='product.element.props.seller'
                ) {{ product.element.props.seller.props.title }}

              +b.g-cell.g-cols--12.--6-xl
              +b.g-cell.g-cols--12
                //- +b.g-row--appearance_nowrap.--align_center.--space_none.tt-space_mb--3
                  +b.g-cell.g-cols.tt-space_mr--2(
                    style='flex-shrink: 0'
                    v-if='product.element.props.weight.props.img || product.element.props.weight.props.color'
                  )
                    +b.product-weight-color-trigger
                      +e.color.IMG(
                        v-if='product.element.props.weight.props.img'
                        :src='product.element.props.weight.props.img'
                      )
                      +e.color(
                        v-else
                        :style='{ "--color": product.element.props.weight.props.color }'
                      )
                  +b.g-cell.g-cols
                    +b.ds-caption--size_2xs.--color-relief.--medium.P(v-if='product.element.props.weight.props.color_number') {{ product.element.props.weight.props.color_number }} ({{ product.element.props.weight.props.name }})
                    +b.ds-caption--size_2xs.--color-relief.--medium.P(v-else) {{ product.element.props.weight.props.name }}
                +b.ds-caption--size_2xs.--medium.--color_semigrey.P(v-if='product.parameters && product.parameters.quality_type_id') {{ product.parameters.quality_type_title }}
              +b.g-cell.g-cols--12.tt-space_mt--3.is-disable-xl
              //-   +b.g-row
              //-     +b.g-cell.g-cols--6
              //-       +b.ds-caption--size_xs.--medium.P(
              //-         v-if='product.element.props.weight'
              //-       ) {{ product.element.props.weight.props.name }}
              //-     +b.g-cell.g-cols--4
              //-       +b.ds-caption--size_xs {{ _('Артикул:') }} {{ product.element.props.vendor_code }}
              //-       slot(
              //-         name='price',
              //-         :price='product.price'
              //-       )
              //-         template(
              //-           v-if='saleInfo && saleInfo.parameters && saleInfo.parameters.calculated_price && $options.RED_PRICE_DESCRIPTORS.includes(saleInfo.element.type)'
              //-         )
              //-           +b.ds-caption--size_sm.--semibold.--appearance_right.--appearance_line-througt.P(
              //-             v-html='getSplittedHtml(product.price)'
              //-           )
              //-           +b.ds-caption--size_sm.--semibold.--appearance_right.--color_red.P(
              //-             v-html='getSplittedHtml(saleInfo.parameters.calculated_price)'
              //-           )
              //-         template(
              //-           v-else-if='promo && promo.parameters && Number(promo.parameters.calculated_price)'
              //-         )
              //-           +b.ds-caption--size_sm.--semibold.--appearance_right.--appearance_line-througt.P(
              //-             v-html='getSplittedHtml(product.price)'
              //-           )
              //-           pre !
              //-           +b.ds-caption--size_sm.--semibold.--appearance_right.--color_red.P(
              //-             v-html='getSplittedHtml(promo.parameters.calculated_price)'
              //-           )
              //-         +b.ds-caption--size_sm.--semibold.--appearance_right.P(
              //-           v-else
              //-           v-html='getSplittedHtml(product.price)'
              //-         )
              //-     slot(
              //-       name='mob-sale',
              //-     )
              //- +b.g-cell.g-cols--12(
              //-   v-if='saleInfo && saleInfo.element && $options.DISCOUNT_CONDITION_DESCRIPTORS.includes(saleInfo.element.type)'
              //- )
              //-   +b.ds-caption--size_xsm.--medium.--color_red.--appearance_right.P.is-disable-xl {{ _('Скидка') }} #[+b.ds-caption--size_sm.--color_red.SPAN {{ saleInfo.parameters.title }} ]

        row(
          :justify='isSimple ? "end" : "start"'
          align='center'
        )
          //- appearance='nowrap'
          +b.g-cell.g-cols--12-xs.is-disable-xl(v-if='!isSimple')
            +b.g-row.--justify_between
              +b.g-cell.g-cols.--narrow-sm(v-if="!isGiftSelect")
                +b.tt-cart-product-article
                  +b.ds-caption--size_xs.SPAN {{ _('Артикул:') }} {{ product.element.props.vendor_code }}
              +b.g-cell.g-cols.--narrow-sm(v-if="!isCartModal && bonus")
                +b.tt-cart-product-cashback
                  +e.icon.SVG(:title='_("cashback")' xmlns='http://www.w3.org/2000/svg', width='20', height='20', viewBox!='0 0 20 20', fill='none')
                    circle(cx='10' cy='10' r='10' fill='#FF7A00')
                    circle(cx='10' cy='10' r='8.5' fill='#FF7A00' stroke='white')
                    path(d='M10.5398 15C9.74432 15 9.00568 14.8816 8.32386 14.6448C7.65152 14.3989 7.06439 14.0528 6.5625 13.6066C6.07008 13.1603 5.68655 12.6321 5.41193 12.0219C5.13731 11.4117 5 10.7377 5 10C5 9.2623 5.13731 8.58834 5.41193 7.97814C5.68655 7.36794 6.07008 6.83971 6.5625 6.39344C7.06439 5.94718 7.65152 5.60565 8.32386 5.36885C9.00568 5.12295 9.74432 5 10.5398 5C11.5152 5 12.3769 5.16393 13.125 5.4918C13.8826 5.81967 14.5076 6.29326 15 6.91257L12.8835 8.72951C12.59 8.37432 12.2633 8.10109 11.9034 7.90984C11.553 7.70947 11.1553 7.60929 10.7102 7.60929C10.3598 7.60929 10.0426 7.66393 9.75852 7.77322C9.47443 7.88251 9.22822 8.04189 9.01989 8.25137C8.82102 8.46084 8.66477 8.71585 8.55114 9.01639C8.4375 9.30783 8.38068 9.6357 8.38068 10C8.38068 10.3643 8.4375 10.6967 8.55114 10.9973C8.66477 11.2887 8.82102 11.5392 9.01989 11.7486C9.22822 11.9581 9.47443 12.1175 9.75852 12.2268C10.0426 12.3361 10.3598 12.3907 10.7102 12.3907C11.1553 12.3907 11.553 12.2951 11.9034 12.1038C12.2633 11.9035 12.59 11.6257 12.8835 11.2705L15 13.0874C14.5076 13.6976 13.8826 14.1712 13.125 14.5082C12.3769 14.8361 11.5152 15 10.5398 15Z' fill='white')
                  +e.value.ds-caption--size_sm.--semibold(v-html='getSplittedHtml(bonus)')
          +b.g-cell.g-cols--3.--2-xl.is-visible-xl
          +b.g-cell.g-cols(:class="isCartModal ? 'g-cols--12' : 'g-cols--6-xl'")
            slot(name='counter', :count='product.quantity')
              row(:justify="isCartModal ? 'end' : 'start'" align='center' :appearance='["column-reverse-till-m2d", "nowrap", "spaced"]')
                cell(v-if='isCartModal')
                  +b.ds-caption--size_sm.--medium.--appearance_right.P {{ product.quantity }} {{ _('шт.') }}
                cell(v-else)
                  +b.COUNTER.tt-counter--variant_1(
                    :amount='product.quantity',
                    :disable='isSale || disabled || isCartModal'
                    :max-count='product.element.props.stock'
                    :key='`${product.id}_${price}`'
                    @change='$emit("updateCart", $event)'
                    :variant='product.element.id'
                    :show-error='stockInfo && !stockInfo.is_valid && stockInfo.quantity > stockInfo.stock_quantity_1c'
                  )
          +b.g-cell(
            v-if='!isCartModal'
            :class='isSimple ? "g-cols--9 g-cols--10-xl" : isGiftSelect ? "g-cols--12" : "g-cols--auto"'
          )
            slot(
              name='total',
            )
              row(
                justify='end'
                align='center'
              )
                //- cell.is-visible-md(
                //-   cols='12-xl'
                //- )
                //-   slot(
                //-     name='pricetips'
                //-   )
                //-     +b.ds-caption--size_xs.--light.--appearance_right.P  {{ _('Сумма:') }}
                cell(
                  cols='12-xs'
                )
                  slot(
                      name='desktop-price',
                      :price='product.price'
                    )
                      +b.g-row.--justify_end.--space_none
                        template(
                          v-if='saleInfo && saleInfo.parameters && saleInfo.parameters.calculated_price && $options.RED_PRICE_DESCRIPTORS.includes(saleInfo.element.type)'
                        )
                          +b.g-cell.g-cols--narrow-xs.--ordered_1
                            +b.ds-caption--size_xs.--medium.--appearance_right.--appearance_line-througt.--color_text-8.P(v-html='getSplittedHtml(product.price *  product.quantity )')
                          +b.g-cell.g-cols--12-xs
                            +b.ds-caption--size_2md.--semibold.--appearance_right.--color_red.P(v-html='getSplittedHtml(price)')
                        template(v-else-if="saleInfo && saleInfo.parameters && (product.parameters.quality_type_id || product.parameters.calculated_price)")
                          +b.g-cell.g-cols--narrow-xs.--ordered_1
                            +b.ds-caption--size_xs.--medium.--appearance_right.--appearance_line-througt.--color_text-8.P(v-html='getSplittedHtml(product.default_price * product.quantity)')
                          +b.g-cell.g-cols--12-xs
                            +b.ds-caption--size_2md.--semibold.--appearance_right.--color_red.P(v-html='getSplittedHtml(price)')
                        
                        template(
                          v-else-if='product.parameters && product.parameters.quality_type_id'
                        )
                          +b.g-cell.g-cols--narrow-xs.--ordered_1
                            +b.ds-caption--size_xs.--medium.--appearance_right.--appearance_line-througt.--color_text-8.P(
                              v-html='getSplittedHtml(product.parameters.quality_type_default_price * product.quantity )'
                            )
                          +b.g-cell.g-cols--12-xs
                            +b.ds-caption--size_2md.--semibold.--appearance_right.--color_red.P(v-html='getSplittedHtml(price)')
                        template(
                          v-else-if='promo && promo.parameters && Number(promo.parameters.calculated_price)'
                        )
                          +b.g-cell.g-cols--narrow-xs.--ordered_1
                            +b.ds-caption--size_2md.--semibold.--appearance_right.--appearance_line-througt.--color_text-8.P(v-html='getSplittedHtml(product.price * product.quantity)')
                          +b.g-cell.g-cols--12-xs
                            +b.ds-caption--size_2md.--semibold.--appearance_right.--color_red.P(v-html='getSplittedHtml(price)')
                        template(v-else)
                          +b.g-cell.g-cols--12-xs
                            +b.ds-caption--size_2md.--semibold.--appearance_right.--color_text-6.P(v-html='getSplittedHtml(price)')
                        template(v-if='product.parameters && (product.parameters.quality_type_id || product.parameters.calculated_price)')
                          +b.g-cell.g-cols--narrow-xs.--ordered_1
                            slot(name='sale')
                              +b.g-row.--justify_end.--space_none
                                +b.g-cell.g-cols(v-if="Number(product.parameters.quality_type_discount)")
                                  +b.tt-cart-product-sale
                                    +b.ds-caption--size_3xs.--color_white.--bold.SPAN -{{ product.parameters.quality_type_discount }}%
                                +b.g-cell.g-cols(v-if='saleInfo && saleInfo.element && $options.DISCOUNT_CONDITION_DESCRIPTORS.includes(saleInfo.element.type)')
                                  +b.tt-cart-product-sale
                                    +b.ds-caption--size_3xs.--color_white.--bold.SPAN {{ saleInfo.parameters.title }}
                                //- template(
                                //-   v-else-if='!isGift && (product.parameters && !product.parameters.is_sale_applied)',
                                //-   v-for='val in product.parameters && product.parameters.campaigns'
                                //- )
                                //-   +b.g-cell.g-cols--5(
                                //-     v-if='$options.DESCRIPTORS.includes(val.descriptor_type.value)'
                                //-   )
                                //-     +b.ds-caption--size_2xs.--regular.--color_red(
                                //-       v-html='val.message[lang]'
                                //-     )
                      
                cell(
                  cols='12-xs'
                )
                  slot(
                    name='sum',
                    :price='price'
                  )
                    template(
                      v-if='saleInfo && saleInfo.parameters && saleInfo.parameters.calculated_price'
                    )
                      ui-currency-converter.ds-caption--appearance_right(
                        :key="price"
                        :price='price'
                        :site-currency="current_site_currency"
                        :national-currency="national_currency"
                        :national-currency-symbol="national_currency_symbol"
                      )
                    template(v-else)
                      ui-currency-converter.ds-caption--appearance_right(
                        :key="price"
                        :price='price'
                        :site-currency="current_site_currency"
                        :national-currency="national_currency"
                        :national-currency-symbol="national_currency_symbol"
                      )
          slot(name='stock')
            template(
              v-if='isLimited && (stockInfo && stockInfo.is_valid || !stockInfo)'
            )
              +b.g-cell.g-cols--12.tt-space_mt--2
                +b.ds-caption--size_2xs.--regular.--color_accent(
                  v-if='!product.element.props.stock'
                ) {{ _('Нет в наличии') }}
                +b.ds-caption--size_2xs.--regular.--color_accent(
                  v-else
                ) {{ _('Макс. кол-во товаров доступное к заказу -') }} &nbsp; {{  product.element.props.stock }} {{ _('шт.') }}
            template(
              v-if='stockInfo && !stockInfo.is_valid'
            )
              +b.g-cell.g-cols--12.tt-space_mt--2
                +b.ds-caption--size_2xs.--regular.--color_red(
                  v-if='!stockInfo.stock_quantity_1c'
                )
                  slot(name='notvalid:delete')
                    span {{ _('Товара нет в наличии, пожалуйста удалите его из корзины') }}
                +b.ds-caption--size_2xs.--regular.--color_red(
                  v-else-if='stockInfo.quantity > stockInfo.stock_quantity_1c'
                ) {{ _('Товара нет в необходимом Вам количестве, доступно ') }} {{ stockInfo.stock_quantity_1c }}
        template(v-if='!disabled')
          +b.tt-cart-actions-dropdown
            ui-dropdown
              template(#default='{ activeState, toggleActive, hide }')
                ui-click-outside(:do='hide')
                  +b.t-dropdown(:class="{ 'is-active': activeState }")
                    +e.single(@click.prevent='toggleActive()')
                      +e.icon.IMG(src='/static/img/redesign/submenu.svg')
                    +e.content-wrapper.--border_none.--space_2md(v-show="activeState")
                      +b.tt-cart-action(@click='$emit("removeFromCart")' v-if='!isCartModal')
                        +e.title
                          +b.ds-caption--size_2md.--semibold.--color_accent {{ _('Delete') }}
                        +e.icon
                          +b.tt-remove-from-cart.--relative.SPAN(
                            :class='{ "is-active": stockInfo && !stockInfo.stock_quantity_1c }'
                            v-if='!isSale'
                          )
                            +e.icon
                              +b.circle-btn--accent.--clear.--transparent.BUTTON(
                                  :title="_('Remove from cart')"
                                )
                                  +e.icon.IMG(src='/static/img/redesign/trash-new.svg')
                      add-to-favorites(
                        :id='product.element.id'
                        :is-liked="product.element.props.is_favorite"
                        v-if='is_auth'
                      )
                        //- @hook:remove="$emit('hook:remove', $event)"
                        template(#default='{ add, is_added, remove }')
                          +b.tt-cart-action(v-if='is_added' @click.prevent='remove')
                            +e.title
                              +b.ds-caption--size_2md.--semibold.--color_accent.--appearance_nowrap {{ _('In favorite') }}
                            +e.icon
                              +b.circle-btn--accent.--clear.--transparent.BUTTON(
                                :title="_('В избранном')"
                              )
                                +e.icon.IMG(
                                  src="/static/img/full-heart.svg"
                                  :alt='_("full heart")'
                                )
                          +b.tt-cart-action(@click.prevent='add' v-else)
                            +e.title
                              +b.ds-caption--size_2md.--semibold.--color_accent.--appearance_nowrap {{ _('To favorite') }}
                            +e.icon
                              +b.circle-btn--accent.--clear.--transparent.BUTTON(
                                :title="_('Добавить в избранное')"
                              )
                                +e.icon.icon-like.SPAN
                      modal-trigger(
                        v-else
                        url='UiElements/NotPermission',
                        name='NotPermission',
                      )
                        template(#default='{ open }')
                          +b.tt-cart-action(@click.prevent='open')
                            +e.title
                              +b.ds-caption--size_2md.--semibold.--color_accent.--appearance_nowrap {{ _('To favorite') }}
                            +e.icon
                              +b.circle-btn--accent.--clear.--transparent.BUTTON(
                                :title="_('Добавить в избранное')"
                              )
                                +e.icon.icon-like.SPAN

</template>
<script>

import {
  mapActions,
} from 'vuex'

import {
  changeGifts,
  cleanGifts,
  createGifts,
} from '@api/cart.service.js'

import GiftChangeVariants from '@app/Cart/GiftChangeVariants'

const RED_PRICE_DESCRIPTORS = [
  'sales.pricefromquantitydescriptor',
  'sales.pricefromtotalquantitydescriptor',

]
const DISCOUNT_CONDITION_DESCRIPTORS = [
  'sales.discountfromquantitydescriptor',
  'sales.discountfromsumdescriptor',
]
const DESCRIPTORS = [
  'discount_from_quantity',
  'discount_from_summ',
  'price_from_quantity',
]

const PROMO_TYPE = 'sales.promocode'

export default {
  name: 'product-base-view',
  DESCRIPTORS,
  RED_PRICE_DESCRIPTORS,
  DISCOUNT_CONDITION_DESCRIPTORS,
  PROMO_TYPE,
  props: {
    isGift: {},
    product: {
      default: () => { },
    },
    price: {
      default: '0.00',
    },
    isSale: {
      default: () => false,
    },
    isSimple: {
      default: () => false,
    },
    isGiftSelect: {
      default: () => false,
    },
    isCartModal: {
      default: () => false,
    },
    load: {},
    disabled: {
      default: () => false,
    },
    parent: {},
    relations: {
      default: () => [],
    },
    group_id: {},
    set: {},
  },
  data() {
    return {
      current_site_currency: window.current_site_currency,
      national_currency: window.national_currency,
      national_currency_symbol: window.national_currency_symbol,
      currency: window.currency,
      lang: window.language,
      localLoad: false,
      is_auth: window.authent,
    }
  },
  computed: {
    promo() {
      return this.relations.find(e => e.element.type === PROMO_TYPE)
    },
    saleInfo() {
      if (this.relations.length) {
        const [rel] = this.relations
        return rel
      }
      return {}
    },
    isLimited() {
      return this.product.quantity >= this.product.element.props.stock
    },
    stockInfo() {
      return this.product.element.stock_info
    },
    bonus() {
      return this.product?.parameters?.bonus_amount
    },
  },
  methods: {
    ...mapActions('cart', [
      'getCart',
    ]),
    openGiftVariants() {
      const pr = arg => new Promise((resolve, reject) => {
        if (arg) {
          resolve(arg)
          return
        }
        reject(new Error('Promise is rejected'))
      }).then(res => {
        this.getCart(res)
      })
      console.log(this.product);
      this.$modal.show(
        GiftChangeVariants,
        {
          id: this.parent,
          promise: pr,
          count: this.product.quantity,
          group_id: this.group_id,
          set: {
            id: this.group_id,
            base: this.set,
            relations: this.relations,
          },
        }, {
          height: 'auto',
          classes: ['cart-modal'],
          adaptive: true,
          scrollable: true,
        }
      )
    },
    async changeGift(data) {
      await cleanGifts.execute({}, { group_id: this.group_id })
      try {
        this.localLoad = true
        await createGifts.execute({}, data)
        await this.getCart()
        this.localLoad = false
      } catch (e) {
        this.localLoad = false
      }
    },
  },
}
</script>
